<template>
<div class="chapter">
<div class="inner_page">
<p class="dedicenter"><a id="pIV"></a>For Mark, Cathy and Isabella</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?c521c222